import React, { Component } from "react";
import { Router, Route, Redirect, IndexRoute, hashHistory } from "react-router";

import App from "./App";
// Início dos imports do módulo de autenticação
import Login from "../pages/auth/login/login";
import Register from "../pages/auth/register/register";
import Logout from "../pages/auth/logout/logout";
import ForgotPassword from "../pages/auth/forgotPassword/forgotPassword";
import RestorePassword from '../pages/auth/restorePassword/restorePassword';
// Fim dos imports do módulo de autenticação

// Início dos imports dos módulos
import { adminRouters } from "../modules/admin/main/routes-module-admin";
import { systemRouters } from "../modules/system/main/routes-module-system";
import Home from "../modules/system/pages/home/home";
// Fim dos imports dos módulos
import PrintPage from '../pages/print/print';
import Unauthorized from "../pages/unauthorized/unauthorized";

export default class Routes extends Component {
	render() {
		return (
			<Router history={hashHistory}>
                <Route path='/login' component={(props) => <Login {...props} />} />
                <Route path='/cadastrar' component={(props) => <Register {...props} />} />
                <Route path='/logout' component={(props) => <Logout {...props} />} />
                <Route path='/esqueci-minha-senha' component={(props) => <ForgotPassword {...props}/>} />
                <Route path='/recuperar-senha/:token' component={(props) => <RestorePassword {...props}/>} />
                <Route path='/imprimir' component={(props) => <PrintPage {...props}/>} /> 
                <Route path='/401' component={(props) => <Unauthorized {...props}/>} /> 
                <Route path='/' component={(props) => <App {...props} />}>
                    <IndexRoute component={(props) => <Home {...props} />} />
					{systemRouters}
					{adminRouters}
				</Route>
				{/* <Route path='/401' component={NotAuthorized} /> */}
				<Redirect from="*" to="/" />
			</Router>
		);
	}
}
